<template>
<div class="animated fadeIn">
  <div class="card dash-field">
    <div class="row m-0">
      <div class="card-body col-md-10">
        <h3>User exam progress</h3>
      </div>
      <div class="col-md-2 m-auto">
        <button type="button" class="btn btn-delete" @click="resetAllByUser()">
          <!-- icon icon="plus"></icon --> {{$t('RESETEXAM')}}
        </button>
      </div>
    </div>
  </div>
  <div class="card">
    <div class="card-body">
      <div class="row">
        <div class="col-sm-12">
          <table class="table table-foursight table-striped table-hover table-sm">
            <thead>
              <tr>
                <th>{{$t('TITLE')}}</th>
                <th>{{$t('DESCRIPTION')}}</th>
                <th>{{$t('RESETCHAPTER')}}</th>
                <th>{{$t('STATUS')}}</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="item in response.root">
                <tr class=" table-ellipsis">
                  <td v-html="item.title"></td>
                  <td v-html="item.contentOut"></td>
                  <td>
                      <b-button type="button" size="sm" variant="delete" @click="resetChapeterByUser(item)" >{{$t('RESETCHAPTER')}}</b-button>
                  </td>
                  <td>
                    <button type="button" class="btn btn-primary btn-sm" @click="markQuiz(item)" v-if="item.answersSubmit == 1 && item.isComplete==0">{{$t('MARKQUIZ')}}</button>
                    <p v-else-if="item.isComplete==1" class="completed">{{$t('COMPLETED')}}</p>
                    <p v-else>{{$t('NOTCOMPLETED')}}</p>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <b-modal ref="formmodal" :title="$t('MARKEXAMFORM')" ok-title="submit" hide-footer size='xl' no-close-on-backdrop>
    <div class="d-block">
      <markexamform v-bind:quizPages="quizPages"></markexamform>
    </div>
    <div class="text-right">
      <b-btn class="mt-3" variant="secondary-trans mr-4" @click="hideModal">{{$t('CANCEL')}}</b-btn>
      <b-btn class="mt-3" variant="primary" @click="submitData(quizPages)">{{$t('SAVE')}}</b-btn>
    </div>
  </b-modal>
</div>
</template>

<script>
import
{
  mapActions,
  mapGetters
}
from 'vuex'
import Api from '@/api/training/TrainingChapters'
import MarkExamForm from './MarkExamForm'
import ExamApi from '@/api/exam/Exam'

export default
{
  name: 'TrainingChapters',
  components:
  {
    markexamform: MarkExamForm
  },
  data: function()
  {
    return {
      response:
      {},
      quizPages: [],
      chapterId: null,
      userId: null,
      paginationPages:
      {
        query: '',
        currentPage: 1,
        limit: 1,
        searchTimeout: false
      }
    }
  },
  created()
  {
    var me = this;
    me.getData();
  },
  methods:
  {
    async resetChapeterByUser(item)
    {
        const me = this;
        try
        {
            me.$store.commit('setModalAlert',
            {
              text: me.$i18n.t('AREYOUSHURE'),
              btnAction: async () =>
              {
                const data = await ExamApi.resetChapeterByUser({userId: me.$route.params.userId, trainingChapterId: item.chapterId});
                me.$notify.notice(data);

                if (data.error)
                {
                    throw (data);
                }
                else
                {
                  await me.getData();
                }
              }
            })
        }
        catch (e)
        {
            console.log(e);
            me.$notify.notice(e);
        }
    },
    async resetAllByUser()
    {
        const me = this;
        try
        {
          me.$store.commit('setModalAlert',
          {
            text: me.$i18n.t('AREYOUSHURE'),
            btnAction: async () =>
            {
              const data = await ExamApi.resetAllByUser({userId: me.$route.params.userId});
              me.$notify.notice(data);

              if (data.error)
              {
                  throw (data);
              }
              else
              {
                await me.getData();
              }
            }
          })            
        }
        catch (e)
        {
            console.log(e);
            me.$notify.notice(e);
        }
    },
    async getData()
    {
      var me = this;
      try
      {
        var data = await Api.selectForExamMarking(
        {
          'userId': me.$route.params.userId
        });
        if (data.error && data.error == true)
        {
          me.$notify.notice(data);
          me.loading = false;
          return;
        }

        me.response = data;
      }
      catch (e)
      {
        me.$notify.notice(e);
      }
    },
    async markQuiz(item)
    {
      var me = this;
      try
      {
        me.chapterId = item.chapterId;
        me.userId = me.$route.params.userId;

        var response = await ExamApi.selectMarkExamRow(
        {
          'chapterId': item.chapterId,
          'userId': me.$route.params.userId
        });

        me.quizPages = response.root;

        me.$refs.formmodal.show();
      }
      catch (e)
      {
        me.$notify.notice(e);
      }
    },
    async submitData(item)
    {
      var me = this;
      try
      {
        var data = await ExamApi.marklExamAnswers(
        {
          'chapterId': me.chapterId,
          'userId': me.userId,
          'answers': item
        });
        if (data.error)
        {
          me.$notify.notice(data);
          me.formError = data;
        }
        else
        {
          me.$notify.notice(data);
          me.$refs.formmodal.hide();
          await me.getData();
        }
      }
      catch (e)
      {
        me.$notify.notice(e);
      }
    },
    hideModal()
    {
      var me = this;
      this.$refs.formmodal.hide();
    }
  },
  watch:
  {

  },
  computed:
  {
    getParamsPages: function()
    {
      var me = this;
      var data = Object.assign(
      {}, me.paginationPages,
      {});
      data.start = (data.currentPage - 1) * data.limit;
      return data;
    }
  }
}
</script>
